import { useDebugValue } from 'react';
import { useSelector } from 'react-redux';
import { AsyncEntity } from '../../global';
import { RootState } from '../../store';
import { locationsEntitySelectors } from './locations.state';
import { CompanyLocation } from './locations.types';

export const useLocationsState = (): RootState['locations'] => {
  const locations = useSelector<RootState, RootState['locations']>(state => state.locations);

  useDebugValue(locations);

  return locations;
};

export const useLocationsValues = (): CompanyLocation[] => {
  const locations = useSelector<RootState, RootState['locations']>(state => state.locations);

  const result = locationsEntitySelectors.selectAll(locations);

  useDebugValue(result);

  return result;
};

export const useLocationByCode = (code: string): AsyncEntity<CompanyLocation> | null => {
  const locations = useSelector<RootState, RootState['locations']>(state => state.locations);

  const result = locationsEntitySelectors.selectById(locations, code) || null;

  useDebugValue(result);

  return result;
};
